import classnames from 'classnames';
import React from 'react';
import Text from '../Text';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    text: {
        margin: Tokens.spacing30
    },
    textDown: {},
    textDownContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    textUp: {},
    textUpContainer: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center'
    },
    h1Size: {
        fontSize: Tokens.fontSizeHeader1
    },
    h2Size: {
        fontSize: Tokens.fontSizeHeader2
    },
    h3Size: {
        fontSize: Tokens.fontSizeHeader3
    },
    h4Size: {
        fontSize: Tokens.fontSizeHeader4
    }
});
const defaultProps = {
    align: 'center',
    textDown: '',
    textUp: ''
};
const UpDownLabel = (props) => {
    const { align, classes, colorTextDown, colorTextUp, indicatorDown, indicatorUp, sizeTextDown, sizeTextUp, textDown, textUp, weightTextDown, weightTextUp, withMarginTextDown, withMarginTextUp } = props;
    let classTextUp = classes.textUp;
    if (withMarginTextUp) {
        classTextUp = classnames(classTextUp, classes.text);
    }
    let classTextDown = classes.textDown;
    if (withMarginTextDown) {
        classTextDown = classnames(classTextDown, classes.text);
    }
    let newSizeTextUp = sizeTextUp;
    if (sizeTextUp) {
        switch (sizeTextUp) {
            case 'h1':
                classTextUp = classnames(classTextUp, classes.h1Size);
                newSizeTextUp = undefined;
                break;
            case 'h2':
                classTextUp = classnames(classTextUp, classes.h2Size);
                newSizeTextUp = undefined;
                break;
            case 'h3':
                classTextUp = classnames(classTextUp, classes.h3Size);
                newSizeTextUp = undefined;
                break;
            case 'h4':
                classTextUp = classnames(classTextUp, classes.h4Size);
                newSizeTextUp = undefined;
                break;
        }
    }
    let newSizeTextDown = sizeTextDown;
    if (sizeTextDown) {
        switch (sizeTextDown) {
            case 'h1':
                classTextDown = classnames(classTextDown, classes.h1Size);
                newSizeTextDown = undefined;
                break;
            case 'h2':
                classTextDown = classnames(classTextDown, classes.h2Size);
                newSizeTextDown = undefined;
                break;
            case 'h3':
                classTextDown = classnames(classTextDown, classes.h3Size);
                newSizeTextDown = undefined;
                break;
            case 'h4':
                classTextDown = classnames(classTextDown, classes.h4Size);
                newSizeTextDown = undefined;
                break;
        }
    }
    return (React.createElement(React.Fragment, null,
        indicatorUp ? (React.createElement("div", { className: classes.textUpContainer },
            textUp ? (React.createElement(Text, { align: align, className: classTextUp, color: colorTextUp, size: newSizeTextUp, weight: weightTextUp }, textUp)) : undefined,
            indicatorUp)) : (React.createElement(Text, { align: align, className: classTextUp, color: colorTextUp, size: newSizeTextUp, weight: weightTextUp }, textUp)),
        indicatorDown ? (React.createElement("div", { className: classes.textDownContainer },
            textDown ? (React.createElement(Text, { align: align, className: classTextDown, color: colorTextDown, size: newSizeTextDown, weight: weightTextDown }, textDown)) : undefined,
            indicatorDown)) : (React.createElement(Text, { align: align, className: classTextDown, color: colorTextDown, size: newSizeTextDown, weight: weightTextDown }, textDown))));
};
UpDownLabel.defaultProps = defaultProps;
export default withStyles(styles)(UpDownLabel);
